import template from './sw-cms-block-acris-blog-content.html.twig';

const { Component } = Shopware;

Component.register('sw-cms-block-acris-blog-content', {
    template
});
